/* globals apiConn, WURFL */

let React = require('react');

let Masonry = require('react-masonry-component');
let InfiniteScroll = require('react-infinite-scroll')(React);
let MyCard = require('./mycard');
let CategorySlider = require('./slider');
let CategoryBlurb = require('./category-blurb');
let OurChefs  = require('./chefs');
import Slider from 'react-slick';

// let CurrentRecipes = require('./current-recipes');

const eventHandler = require('./eventhandler.js');

// Options
const masonryOptions = {};

let mixins = [];

let device = 'desktop';

if (WURFL.is_mobile) {
  device = WURFL.form_factor === 'Tablet' ? 'tablet' : 'mobile';
}

let MyGallery = React.createClass({
  mixins: mixins,

  propTypes: {
    filter: React.PropTypes.object,
    category: React.PropTypes.string
  },

  getInitialState: function () {
    let out = {
      page: 0,
      hasMore: false,
      threshold: 6,
      entries: [],
      filter: this.props.filter,
      adHeight: {},
      adSize: {},
      isMobile: window.innerWidth < 640
    };

    return out;
  },

  componentWillReceiveProps: function (props) {
    let out = {
      page: 0,
      hasMore: false,
      threshold: 6,
      entries: [],
      filter: props.filter,
      adHeight: {},
      adSize: {}
    };

    this.state = out;
    // this.setState(out);
    this.loadMoreArticles(0);
  },

  componentDidMount: function () {
    this.loadMoreArticles(0);
    window.resizeAdElement = this.resizeAdElement;
    window.addEventListener('resize', this.setIsMobile)
  },

  componentWillUnmount: function () {
    window.resizeAdElement = false;
    window.removeEventListener('resize', this.setIsMobile)
  },

  setIsMobile: function () {
    this.setState({ isMobile: window.innerWidth < 640 })
  },

  resizeAdElement: function (id, height, width) {
    var adHeight = this.state.adHeight;
    adHeight[id] = height;

    var adSize = this.state.adSize;
    adSize[id] = {width: width, height: height};

    this.setState({adHeight: adHeight, adSize: adSize});
  },

  loadPage: function (page, cb) {
    let filters = this.state.filter;

    //$profiles = $this->engine->APIHandle->doCall('ProfileHandler', 'getActiveProfiles');
    if (!filters) {
      filters = {};
    }

    if (filters.type === 'profile') {
      apiConn.doCall('profilehandler', 'getActiveProfiles', { }, (status, profiles) => {
        if (status) {
          const data = {
            total: profiles.length,
            data: profiles
          };

          cb(null, data);
        } else {
          let err = 'failed to load entries';
          cb(err, null);
        }
      });
    } else if (filters.type === 'seek') {
      /*
      $this->filters = array();
      $this->filters['num_results'] = 6;
      $this->filters['page'] = isset($this->filters['page'])?$this->filters['page']:1;
      $this->filters['targets'] = array('recipe', 'article', 'test', 'product','profile');

      $this->months = array('jan','feb','mar','apr','maj','jun','jul','aug','sep','okt','nov','dec');
      */

      /*
      if(isset($query['vad']) && $query['vad'] != 'allt'){
        if(is_array($query['vad'])){
          $this->filters['targets'] = array();
          for($i = 0; $i < count($query['vad']); $i++){
            $this->filters['targets'][] = Translate::toEng($query['vad'][$i]);
          }
        }else{
          $this->filters['targets'] = array(Translate::toEng($query['vad']));
        }
      }
      if(isset($query['typ']) && $query['typ'] != 'alla'){
         $this->filters['type'] = $query['typ'];
      }
      if(isset($query['sokning']) && strlen($query['sokning']) >= 2){
        $this->filters['freetext'] = $query['sokning'];
      }
      if(isset($query['skribent']) && $query['skribent'] != 'alla'){
         $this->filters['author'] = $query['skribent'];
      }
      if(isset($query['land']) && $query['land'] != 'alla'){
         $this->filters['country'] = $query['land'];
      }
      */

      // $search = $this->engine->APIHandle->doCall('LookupHandler', 'sitesearch', array('filters' => $this->filters));

      let data = {
        'num_results': 6,
        'page': page + 1,
        'targets': ['recipe', 'article', 'profile'],
        'freetext': filters['seek']
      };

      apiConn.doCall("lookuphandler", 'sitesearch', {filters: data}, (status, data) => {
        if (status) {

          let out = {};
          out.total = data.total;
          out.data = [];

          for (let key in data.targets) {
            let target = data.targets[key];
            let items = target.data.items;

            for (var i = 0; i < items.length; i++) {
              let item = items[i];
              out.data.push(item);
            }
          }

          cb(null, out);
        } else {
          let err = 'failed to load entries';
          cb(err, null);
        }
      });
    } else if (filters.type === 'related') {
      let data_id = filters.eid;
      let data_type = 'entry';

      let initdata = {
        'rid': data_id,
        'rtype': data_type,
        'page': page + 1,
        'num': {
          'offset': 0,
          'numget': this.state.threshold,
          'level': 0,
          'typeget': 'all'
        }
      };

      apiConn.doCall('entryhandler', 'getRelatedEntries', initdata, (status, data) => {
        if (status) {
          for (let i = 0; i < data.data.length; i++) {
            let item = data.data[i];
            item.id = item.eid;
          }

          cb(null, data);
        } else {
          let err = 'failed to load entries';
          cb(err, null);
        }
      });
    } else {
      filters.page = page + 1;
      filters.perpage = this.state.threshold;
      filters.sort = 'publish';
      filters.order = 'DESC';

      apiConn.doCall('entryhandler', 'query', {filters: filters}, (status, data) => {
        if (status) {
          cb(null, data);
        } else {
          let err = 'failed to load entries';
          cb(err, null);
        }
      });
    }
  },

  loadMoreArticles: function (page){
    const { category } = this.props;
    if ( category === 'start' && page > 0) {
      return true;
    }

    if(page > 0 && this.state.entries.length === 0) {
      return true
    }

    this.loadPage(page, function (err, res) {
      if(err){
        console.log('LOAD ERROR', err);
      }else{
        const total = res.total;
        const to = page * this.state.threshold;

        let hasMore = false;
        if (to < total) {
          hasMore = true;
        }

        var entries = this.state.entries.concat(res.data);

        var state = {
          page: page,
          hasMore: hasMore,
          entries: entries
        };

        this.setState(state);
      }
    }.bind(this));
  },

  getLoaderElement: function () {
    const { category } = this.props;
    if ( category === 'start' ) {
      return (<div />);
    } else {
      return (<div><img src="/public/assets/img/icons/loader.gif" alt="Loading" /> </div>);
    }
  },

  /*
  runMobileAdds: function() {
    let _this = this;

    if (_this.addaddid) {
      clearTimeout(_this.addaddid);
    }

    _this.addaddid = setTimeout(function () {
      _this.addaddid = null;

      if (_this.adsToAdd) {
        for (let key in _this.adsToAdd) {
          var addData = _this.adsToAdd[key];

          if (!addData.drawn) {
            var id = addData.id;

            let element = $('#' + id);

            element.height(element.width());

            //element.html("<script type='text/javascript' src='http://script.tailsweep.com/js/2/24/2488766_2.js'></script>");

            // element.html("<div style='background:#00ff00; height:400px'>AD AD AD</div>");
            let holder = false;

            if(device == 'tablet'){
              //holder = $("<div class='article-list-item l-grid__item desk-u-width-1-of-3 lap-u-width-1-of-2 palm-u-width-1-of-1 u-margin-b-m'></div>");
            }else{
              //holder = $("<div class='article-list-item l-grid__item desk-u-width-1-of-3 lap-u-width-1-of-2 palm-u-width-1-of-1 u-margin-b-m'></div>");
              holder = $("<div class='article-list-item l-grid__item u-margin-b-m'></div>")
              //holder = false;
            }

            //console.log('AdHandler', window.adHandler.insertAd);

            window.adHandler.insertAd(element, 'inside', 'ajax', holder);

            addData.drawn = true;
          }
        }
      }
    }, 100);
  },
  */

  getMoreSlides: function (index, count) {
    const { hasMore, page } = this.state
    if (hasMore && (count - index < 3)) {
      this.loadMoreArticles(page + 1)
    }
  },

  render () {
    const { category, filter } = this.props;
    if (!this.adsToAdd) {
      this.adsToAdd = {};
    }

    const children = [];
    const childIds = [];
    let filters = this.state.filter;

    let newAds = false;
    for (let a = 0; a < this.state.entries.length; a++) {
      let card = this.state.entries[a];

      if (filters.type === 'profile') {
        card.type = 'profile';
      }

      let key = 'article_' + card.id;
      childIds.push(card.id);

      if (this.state.isMobile) {
        children.push(<div><MyCard id={key} key={key} card={card} category={category} /></div>);
      } else {
        children.push(<MyCard id={key} key={key} card={card} category={category} />);
      }

      /*
      let adKey = 'add_' + key;

      if (WURFL.is_mobile && device !== 'tablet') {
        if (a !== 0 && (a % 5) === 0) {

          // if (!this.adsToAdd[adKey]) {
          //   newAds = true;
          //   this.adsToAdd[adKey] = {id: adKey};
          // }

          // const style = {};
          // style['height'] = '390px';
          // // style['background'] = '#000000';
          // // <div class='article-list-item l-grid__item desk-u-width-1-of-3 lap-u-width-1-of-2 palm-u-width-1-of-1 u-margin-b-m'></div>
          // children.push(<div className='article-list-item l-grid__item desk-u-width-1-of-3 lap-u-width-1-of-2 palm-u-width-1-of-1 u-margin-b-m' style={style} id={adKey} key={adKey}></div>);


          let height = '0px';

          if (this.state && this.state.adHeight && this.state.adHeight[adKey]) {
            height = this.state.adHeight[adKey];
          }

          const style = {};
          style['height'] = height;

          const iframeStyle = {};
          iframeStyle['overflow'] = 'hidden';
          iframeStyle['height'] = height;

          let iframePath = '/ad_widepsace.php?resize=1&id=' + adKey;

          children.push(<div className='article-list-item l-grid__item desk-u-width-1-of-3 lap-u-width-1-of-2 palm-u-width-1-of-1 u-margin-b-m' style={style} id={adKey} key={adKey}>
            <iframe src={iframePath} sandbox='allow-same-origin allow-scripts allow-forms allow-popups' scrolling='no' style={iframeStyle} frameBorder='0'/>
          </div>);
        }
      } else if(!WURFL.is_mobile) {
        if (a !== 0 && (a % 15) === 0) {
          let height = 170;
          let width = 600;

          if (this.state && this.state.adHeight && this.state.adHeight[adKey]) {
            height = this.state.adHeight[adKey];
          }

          const style = {};
          const iframeStyle = {};
          iframeStyle['overflow'] = 'hidden';

          if (this.state && this.state.adSize && this.state.adSize[adKey]) {
            height = this.state.adSize[adKey]['height'];
            width = this.state.adSize[adKey]['width'];
          }

          style['height'] = iframeStyle['height'] = height + 'px';

          var className = 'article-list-item l-grid__item u-margin-b-m';

          if (width < 310) {
            className += ' desk-u-width-1-of-3 lap-u-width-1-of-2 palm-u-width-1-of-1';
          } else {
            className += ' desk-u-width-2-of-3 lap-u-width-1-of-2 palm-u-width-1-of-1';
          }

          let iframePath = '/ad_tailsweep.php?type=mid&resize=1&id=' + adKey;

          children.push(<div className={className} style={style} id={adKey} key={adKey}>
            <iframe src={iframePath} sandbox='allow-same-origin allow-scripts allow-forms allow-popups' scrolling='no' style={iframeStyle} frameBorder='0'/>
          </div>);
        }
      }*/
    }

    /*
    if (newAds) {
      this.runMobileAdds();
    }
    */

    let BlockOne = '';
    let BlockTwo = '';
    let BlockThree = '';
    let BlockFour = '';
    let Title = '';

    if (category === 'start') {
      Title = (
        <div className="u-text-center">
          <h1 className="title-large u-margin-t-l u-margin-b-l u-padding-l-s u-padding-r-s">Aktuellt</h1>
        </div>
      );
      BlockOne = (
        <CategorySlider />
      );
      BlockTwo = (
        <div className="l-grid l-grid--flush">
          <CategoryBlurb />
        </div>
      );
      BlockThree = (
        <div className="container u-text-center">
          <OurChefs />
        </div>
      );
      // BlockFour = (
      //   <div>
      //     <div className="container">
      //       <CurrentRecipes
      //         exclude={childIds}
      //       />
      //     </div>
      //   </div>
      // );
    }

    let settings = {
      autoplay: false,
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '0',
      variableWidth: true,
      afterChange: (index) => {
        this.getMoreSlides(index, children.length)
      }
    };

    return (
      <div>
        {BlockOne}
        <div className="container">
          {Title}
          <div className="l-grid article-list">
            {this.state.entries.length > 0 &&
            (this.state.isMobile ?
                  <Slider {...settings}>
                    {children}
                  </Slider> :
                  <InfiniteScroll
                      className="article-list"
                      ref='masonryContainer'
                      pageStart={this.state.page}
                      loader={this.getLoaderElement()}
                      loadMore={this.loadMoreArticles}
                      hasMore={this.state.hasMore}
                      threshold={this.state.threshold}>
                    <Masonry options={masonryOptions}>
                      {children}
                    </Masonry>
                  </InfiniteScroll>
            )
            }
          </div>
          {category === 'start' && <div className="news-buttons-container">
            <a href="/recept" type="button" className="btn">Se alla recept</a>
            <a href="/artiklar" type="button" className="btn">Se alla artiklar</a>
          </div>}
        </div>
        {BlockTwo}
        {BlockThree}
        {BlockFour}
      </div>
    );
  }
});

let MasonryModule = React.createClass({

  propTypes: {
    filter: React.PropTypes.object,
    category: React.PropTypes.string
  },

  getInitialState: function () {
    let filtersData = $('#recent_updates_filters')[0].dataset;
    let inFilterData = false;

    if (filtersData && filtersData.filters && filtersData.filters.length > 0) {
      try {
        let inFilterJSON = decodeURIComponent(filtersData.filters);
        inFilterData = JSON.parse(inFilterJSON);
      } catch (e) {
        console.log('failed to parse filter indata', e);
      }
    }

    let infilter = this.props.filter;

    if (!infilter) {
      infilter = {};
    }

    if (this.props.category) {
      infilter.vad = this.props.category;
    }

    const filter = this.parseFilterData(infilter);

    if (this.props.category === 'relaterade') {
      filter.eid = inFilterData.eid;
    }

    return {filter: filter};
  },

  parseFilterData: function (data) {
    let out = {};

    if (data && data.vad) {
      const category = data.vad;

      if (data.skribent && data.skribent !== 'alla') {
        out.author = data.skribent;
      }

      switch (category) {
        case 'sok':
          if (data.sokning && data.sokning.length > 0) {
            out.type = 'seek';
            out.seek = data.sokning;
          }

          break;
        case 'recept':
          out.type = 'recipe';

          if (data.typ && data.typ !== 'alla') {
            out.recipe_type = data.typ;
          }

          if (data.tid && data.tid !== 'alla') {
            out.cooktime = data.tid;
          }

          break;
        case 'artiklar':
          if (data.typ && data.typ === 'recension') {
            out.type = 'test';
          } else {
            out.type = 'article';
          }

          break;
        case 'profiler':
          out.type = 'profile';
          break;
        case 'relaterade':
          out.type = 'related';
          break;
      }
    }

    return out;
  },

  gotFilter: function (filter) {
    let filterObj = this.parseFilterData(filter);
    this.setState({filter: filterObj});
  },

  componentDidMount: function () {
    eventHandler.on('filter', this.gotFilter);
  },

  componentWillUnmount: function () {
    eventHandler.removeListener('filter', this.gotFilter);
  },

  render () {
    let filter = this.state.filter;

    return (
      <div>
        <MyGallery
          category={this.props.category}
          filter={filter}
        />
      </div>
    );
  }
});

module.exports = MasonryModule;



// WEBPACK FOOTER //
// ./src/scripts/components/start.js